<script lang="ts" setup>
import { TaskParametersForm, TaskParameterTypeEnum } from "@/components";
import { PropType, ref } from "vue";
import { useRouter } from "vue-router";
import { NamespaceModel } from "../project-namespaces-page/models";

/**Маршруты */
const router = useRouter();

/**Параметры */
defineProps({
  /**ID неймспейса */
  namespaceId: { type: String, required: true },
  /**Информация об области */
  namespace: { type: Object as PropType<NamespaceModel> },
});

/**Компонент формы для настройки параметров */
const $taskParametersForm = ref<InstanceType<typeof TaskParametersForm>>();

/**Проверка наличия изменений в форме перед переходом */
router.beforeEach((to, from, next) => {
  if ($taskParametersForm.value?.haveChanges) {
    $taskParametersForm.value?.openLeaveConfirmation(() => {
      next();
    });
  } else {
    next();
  }
});
</script>
<template>
  <TaskParametersForm
    ref="$taskParametersForm"
    separate-templates
    :type="TaskParameterTypeEnum.Type"
    :entity-id="namespaceId"
    :namespaceName="namespace?.Name"
  />
</template>
